import printJS from "print-js";
import { api_URL } from "./Constantes";

export const printfacdocpdf = (num_facture) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
    const url = `${api_URL}/Print/Documents/Bureautique/${num_facture}/FactureSoc`;
    
    fetch(url, {
      method: 'GET',  
      headers: {
        'user_id': userId,
        'username': username,  
      },
    })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      
      // Utilisez printJS pour imprimer le PDF
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };
  